/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetPeriodUsageSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type GetPeriodUsageRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type GetPeriodUsageSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetPeriodUsageSecurity$outboundSchema: z.ZodMiniType<
  GetPeriodUsageSecurity$Outbound,
  GetPeriodUsageSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getPeriodUsageSecurityToJSON(
  getPeriodUsageSecurity: GetPeriodUsageSecurity,
): string {
  return JSON.stringify(
    GetPeriodUsageSecurity$outboundSchema.parse(getPeriodUsageSecurity),
  );
}

/** @internal */
export type GetPeriodUsageRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const GetPeriodUsageRequest$outboundSchema: z.ZodMiniType<
  GetPeriodUsageRequest$Outbound,
  GetPeriodUsageRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function getPeriodUsageRequestToJSON(
  getPeriodUsageRequest: GetPeriodUsageRequest,
): string {
  return JSON.stringify(
    GetPeriodUsageRequest$outboundSchema.parse(getPeriodUsageRequest),
  );
}
